module.exports = __webpack_public_path__ + "static/img/Triangle@3x.1e1cc67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Triangle@3x.png
// module id = xUes
// module chunks = 1